module.exports = __webpack_public_path__ + "img/Talim Building - Kolhapur.9c144e27.jpg";